import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { EmployeeService } from '../employee.service';

export const useGetEmployees = (
	params?: Employees.EmployeeParams,
	options?: Omit<
		UseQueryOptions<Employees.GetEmployeesResponse, Error>,
		'queryKey' | 'queryFn'
	>,
) => {
	return useQuery({
		queryKey: ['employees', params],
		queryFn: () => EmployeeService.get(params),
		refetchOnWindowFocus: false,
		...options,
	});
};

export const useGetEmployeesByCompany = (
	companyId: string,
	params?: Employees.EmployeeParams,
	options?: Omit<
		UseQueryOptions<Employees.GetEmployeesResponse, Error>,
		'queryKey' | 'queryFn'
	>,
) => {
	return useQuery({
		queryKey: ['employees', 'company', companyId, params],
		queryFn: () => EmployeeService.getByCompany(companyId, params),
		enabled: !!companyId,
		refetchOnWindowFocus: false,
		...options,
	});
};

export const useGetEmployeeStats = (
	options?: Omit<
		UseQueryOptions<Employees.EmployeeStats, Error>,
		'queryKey' | 'queryFn'
	>,
) => {
	return useQuery({
		queryKey: ['employees', 'stats'],
		queryFn: () => EmployeeService.getStats(),
		refetchOnWindowFocus: false,
		...options,
	});
};

export const useGetEmployeeStatsByCompany = (
	companyId: string,
	options?: Omit<
		UseQueryOptions<Employees.EmployeeStats, Error>,
		'queryKey' | 'queryFn'
	>,
) => {
	return useQuery({
		queryKey: ['employees', 'stats', companyId],
		queryFn: () => EmployeeService.getStatsByCompany(companyId),
		enabled: !!companyId,
		refetchOnWindowFocus: false,
		...options,
	});
};
